// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-k_hk","advertDetailHeaderLocation__value":"c-k_hl"};